import { KeyMetric } from '../key-metric';
import {
    TranslationComponent,
    prDocumentVisualizationsSeriesChartLabelsLanguageUnidentified
} from '../translations';

const UNIDENTIFIED_LANGUAGE_CODE = 'zz';

// eslint-disable-next-line complexity
export function getDocumentKeyMetricValue({ document, language, keyMetric }) {
    switch (keyMetric) {
        case KeyMetric.broadcastViewership:
        case KeyMetric.editorialReach:
        case KeyMetric.reach:
        case KeyMetric.socialReach:
            return parseInt(document.reach);

        case KeyMetric.engagement:
            return parseInt(document.engagement);

        case KeyMetric.estimatedViews:
            return parseInt(document.metrics?.views?.origin?.estimated ?? document.metrics?.views?.origin?.total);

        case KeyMetric.language: {
            if (document.language!== UNIDENTIFIED_LANGUAGE_CODE) {
                const languages = new Intl.DisplayNames([language], { type: 'language' });
                return languages.of(document.language);
            }

            return `<${TranslationComponent.tagName} key="${prDocumentVisualizationsSeriesChartLabelsLanguageUnidentified}" language="${language}"></${TranslationComponent.tagName}>`;
        }

        case KeyMetric.locationCountry: {
            const countries = new Intl.DisplayNames([language], { type: 'region' });
            return countries.of(document.country);
        }

        case KeyMetric.newsGuardScore:
            return parseInt(document.sourceAuthority?.newsguardScore ?? 0);

        case KeyMetric.socialEcho:
            return parseInt(document.socialEcho);

        default:
            throw new RangeError(`Cannot get value from document for unknown field. Field request: ${keyMetric}`);
    }

}
